import { render, staticRenderFns } from "./FilePreviewContainer.vue?vue&type=template&id=6a2a2caf&"
import script from "./FilePreviewContainer.vue?vue&type=script&lang=js&"
export * from "./FilePreviewContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports